import { combineReducers } from "redux";

import { teamConfig } from "./team/team.reducers";

export const users = combineReducers({
    teamConfig
});